import React from "react"
import { Container } from "react-bootstrap"

const BannerCategory = ({ title }) => {
  return (
    <section className="cat-banner">
      <Container>
        <div className="cat-banner-heading">
          <h1 className="rb">{title}</h1>
        </div>
      </Container>
    </section>
  )
}

export default BannerCategory
